import * as types from './constants'

const intialState = {
	roleGroupCloneStatus: '',
	roleGroupCloned: null,
	cloneId: null,
	showSelectedRoleGroups: false,
	roleGroupSearchValue: '',
	searchValueOnClick: '',
	associatedGroupSearchValue: '',
}
const roleGroupsReducer = (state = intialState, action) => {
	switch (action.type) {
		case types.ROLE_GROUP_CLONE_STATUS:
			return {
				...state,
				roleGroupCloneStatus: action.status,
			}
		case types.RESET_ROLE_GROUPS:
			return intialState
		case types.ROLE_GROUP_CLONED:
			return {
				...state,
				roleGroupCloned: action.data,
			}
		case types.SET_CLONE_ID:
			return {
				...state,
				cloneId: action.id,
			}
		case types.SET_SHOW_SELECTED_ROLE_GROUP:
			return {
				...state,
				showSelectedRoleGroups: !state.showSelectedRoleGroups,
			}
		case types.SET_ROLE_GROUP_SEARCH_VALUE:
			return {
				...state,
				roleGroupSearchValue: action.value,
			}
		case types.SET_SEARCH_VALUE_ON_CLICK:
			return {
				...state,
				searchValueOnClick: action.value,
			}
		case types.SET_ASSOCIATED_GROUP_SEARCH:
			return {
				...state,
				associatedGroupSearchValue: action.value,
			}
		default:
			return state
	}
}

export default roleGroupsReducer
